<script>
import EventForm from '@events/components/event-form.vue'

export default {
  components: { EventForm },
  props: {
    event: {
      type: Object,
      required: true,
    },
    isLoading: Boolean,
  },
  methods: {
    onSaveClick(payload) {
      this.$emit('save', payload)
    },
    onCancelClick(payload) {
      this.$emit('cancel', payload)
    },
    onCancelEventClick(payload) {
      this.$emit('cancelEvent', payload)
    },
    onDetachEventClick(payload) {
      this.$emit('detachEvent', payload)
    },
  },
}
</script>

<template>
  <EventForm
    :event="event"
    :is-loading="isLoading"
    @save="onSaveClick"
    @cancel="onCancelClick"
    @cancelEvent="onCancelEventClick"
    @detachEvent="onDetachEventClick"
  />
</template>
